import { saveAs } from "file-saver";
import Template from "@/assets/templates/upload-bulk-bookings-template.xlsx";
import { ButtonDropdown, Icon, Typography } from "@/components/atoms";

interface BulkUploadMenuSectionProps {
  /**
   * Opens the bulk upload wizard. Omitted until the wizard exists, in which case only the template
   * download renders — better than shipping a menu item that does nothing.
   */
  onUpload?: () => void;
}

/**
 * The "Bulk Upload Options" group inside the Book a Trip split button (DEV-1215). Shared verbatim by the
 * client, operator and EA portals — the only thing that differs is which client the wizard is then
 * scoped to, which is the caller's business.
 *
 * Mirrors the same group in the Client Manager Actions menu (ClientsActionMenu), down to the divider
 * markup, so the two read identically.
 */
export const BulkUploadMenuSection = ({ onUpload }: BulkUploadMenuSectionProps) => (
  <>
    <ButtonDropdown.Section>Bulk Upload Options</ButtonDropdown.Section>
    {onUpload && (
      <ButtonDropdown.Item onClick={onUpload} className="w-[298px]">
        <Icon name="ExportCurve" className="mr-2 text-neutral-black" size="md" />
        <Typography className="text-neutral-black">Upload Bulk Trips</Typography>
      </ButtonDropdown.Item>
    )}
    <ButtonDropdown.Item onClick={() => saveAs(Template, "upload-bulk-bookings-template.xlsx")} className="w-[298px]">
      <Icon name="excel" isCustom className="mr-2 text-neutral-black" size="md" />
      <Typography className="text-neutral-black">Download Bulk Booking Template</Typography>
    </ButtonDropdown.Item>
  </>
);
